/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import React from "react";
import cn from "classnames";
import s from "./Drawer.module.css";

import { useUI } from "state";

export interface UIGlobalsInterface {
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
  id?: string;
}

interface IDrawer extends UIGlobalsInterface {
  side: "left" | "right";
  variant?: "page" | "component";
  className?: string;
}

const Drawer = ({
  isOpen,
  children,
  side,
  variant = "page",
  className,
}: IDrawer) => {
  const { isSidebarShrunk } = useUI();
  let sideClass;
  let animationClass;
  if (side === "left") {
    className = cn(className, "bg-black sm:bg-secondary-accent");

    if (!isOpen) {
      sideClass = "sm:left-0 lg:left-0 invisible";
    } else {
      sideClass = "left-0 sm:left-16 lg:left-[230px] p-[10px] visible";

      if (isSidebarShrunk) {
        sideClass = sideClass.replace("lg:left-[230px]", "lg:left-[75px]");
      }
    }

    if (isOpen) {
      animationClass = "translate-x-0  transition-all duration-550 ease-in-out";
    } else {
      animationClass = "-translate-x-full";
    }
  }

  if (side === "right") {
    className = cn(className, "bg-black sm:bg-secondary-accent");
    sideClass = "right-0";

    if (isOpen) {
      animationClass = "translate-x-0";
    } else {
      animationClass = "translate-x-full";
    }
  }

  return (
    <aside
      className={cn(s.root, s[variant], sideClass, animationClass, className)}
      test-id="f9gNft1y"
    >
      {children}
    </aside>
  );
};

export default Drawer;
